import './App.css';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { AdminRoute } from './components/ProtectedRoute/ProtectedRoute';
import Navbar from './components/navbar/navbar';
import Home from './components/Home/Home';
import Books from './components/Books/Books';
import BookDetail from './components/BookDetail/BookDetail';
import Authors from './components/Authors/Authors';
import AuthorDetail from './components/AuthorDetail/AuthorDetail';
import Quizzes from './components/Quizzes/Quizzes';
import QuizDetail from './components/QuizDetail/QuizDetail';
import QuizQuestion from './components/QuizQuestion/QuizQuestion';
import QuizSummary from './components/QuizSummary/QuizSummary';
import QuizResults from './components/QuizResults/QuizResults';
import ReadingList from './components/ReadingList/ReadingList';
import QuizEditor from './components/QuizEditor/QuizEditor';
import Admin from './components/Admin/Admin';
import Login from './components/Login/Login';
import Register from './components/Register/Register';
import ForgotPassword from './components/ForgotPassword/ForgotPassword';
import ResetPassword from './components/ResetPassword/ResetPassword';
import Footer from './components/Footer/Footer';

function Layout() {
  return (
    <AuthProvider>
      <div className="App">
        <Navbar />
        <Outlet />
        <Footer />
      </div>
    </AuthProvider>
  );
}

const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      { path: '/', element: <Home /> },
      { path: '/knihy', element: <Books /> },
      { path: '/knihy/:id', element: <BookDetail /> },
      { path: '/autori', element: <Authors /> },
      { path: '/autori/:id', element: <AuthorDetail /> },
      { path: '/kvizy', element: <Quizzes /> },
      { path: '/kvizy/:id', element: <QuizDetail /> },
      { path: '/kvizy/:id/start', element: <QuizQuestion /> },
      { path: '/kvizy/:id/summary', element: <QuizSummary /> },
      { path: '/kvizy/:id/results', element: <QuizResults /> },
      { path: '/seznam-cetby', element: <ReadingList /> },
      { path: '/login', element: <Login /> },
      { path: '/registrace', element: <Register /> },
      { path: '/forgot-password', element: <ForgotPassword /> },
      { path: '/reset-password', element: <ResetPassword /> },
      { path: '/editor-kvizu/*', element: <AdminRoute><QuizEditor /></AdminRoute> },
      { path: '/admin/*', element: <AdminRoute><Admin /></AdminRoute> },
    ],
  },
]);

function App() {
  return (
    <>
      <RouterProvider router={router} />
      <Analytics />
      <SpeedInsights />
    </>
  );
}

export default App;
